// covered-by: frontends/carrie/src/ask-v2/review/__tests__/AskV2ReviewAttentionBanner.test.tsx
import { WarningCircle } from "@phosphor-icons/react";
import { Button } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import {
  useAskPunttReviewAttention,
  useContinueAskPunttReviewAttention,
} from "../../utils/queries/askPuntt";

export function AskV2ReviewAttentionBanner({ chatId }: { chatId: string }) {
  const { t } = useTranslation("ui");
  const query = useAskPunttReviewAttention(chatId);
  const episode = query.data?.episode;
  const continuation = useContinueAskPunttReviewAttention(chatId);
  if (!episode) return null;

  const validationError = continuation.data?.validationErrors[0];
  return (
    <section
      className="border-amber-7 bg-amber-2 mx-4 mt-3 rounded-lg border p-3 text-puntt-neutral-gray-12"
      data-testid="ask-v2-review-needs-attention"
      aria-labelledby="ask-v2-review-needs-attention-title"
    >
      <div className="flex items-start gap-2">
        <WarningCircle
          size={18}
          weight="fill"
          className="text-amber-10 mt-0.5 shrink-0"
          aria-hidden="true"
        />
        <div className="min-w-0 flex-1">
          <h2
            id="ask-v2-review-needs-attention-title"
            className="text-sm font-semibold"
          >
            {t("askV2.reviewAttention.title")}
          </h2>
          <p className="mt-1 text-xs text-puntt-neutral-gray-11">
            {t("askV2.reviewAttention.description")}
          </p>
          <Button
            type="button"
            size="1"
            className="mt-2 cursor-pointer"
            data-testid="ask-v2-review-needs-attention-continue"
            aria-label={t("askV2.reviewAttention.runFullReview")}
            disabled={
              continuation.isPending || episode.state === "continuation_pending"
            }
            onClick={() =>
              continuation.mutate({ episodeId: episode.episodeId })
            }
          >
            {continuation.isPending || episode.state === "continuation_pending"
              ? t("askV2.reviewAttention.starting")
              : t("askV2.reviewAttention.runFullReview")}
          </Button>
          {validationError || continuation.isError ? (
            <p className="text-tomato-11 mt-2 text-xs" role="alert">
              {validationError ?? t("askV2.reviewAttention.failed")}
            </p>
          ) : null}
        </div>
      </div>
    </section>
  );
}
